import React, { ComponentType, FC, ReactNode } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Loaders } from './';

const useStyles = makeStyles(theme => ({
  button: {
    width: 250,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  loader: {
    width: 250,
    margin: `0 auto ${theme.spacing(3)}px`,
  },
}));

interface IProps {
  text: string | ReactNode;
  working?: boolean;
  onClick?: () => void;
  component?: ComponentType;
  to?: string;
}

const SubmitButton: FC<IProps> = ({ text, working, ...props }) => {
  const classes = useStyles();

  return (
    <Button
      type="submit"
      className={classes.button}
      size="large"
      variant="contained"
      color="primary"
      disabled={!!working}
      {...props}
    >
      {working ? <Loaders.Standard height={26} /> : text}
    </Button>
  );
};

SubmitButton.defaultProps = {
  working: false,
};

export default SubmitButton;
